// utils/authStorage.js 该类用于时效性浏览器参数管理
const authStorage = {
  set(key, value, expireSeconds) {
    const data = {
      value,
      expire: Date.now() + expireSeconds * 1000,
    }
    localStorage.setItem(key, JSON.stringify(data))
  },

  get(key) {
    const str = localStorage.getItem(key)
    if (!str) return null

    try {
      const data = JSON.parse(str)
      if (Date.now() > data.expire) {
        localStorage.removeItem(key)
        return null
      }
      return data.value
    } catch (e) {
      return null
    }
  },

  remove(key) {
    localStorage.removeItem(key)
  },
}

export default authStorage
